export const table = {
    primaryData: [
        { title: "ID", value: "id", type: "configue" },
        { title: "Package Name", value: "packageName", type: "configue" },
        { title: "Admission Number", value: "admissionNumber", type: "configue"},
        { title: "Batch Name", value: "batchName", type: "configue" },
        { title: "Class Name", value: "className", type: "configue" },
        { title: "College Name", value: "collegeName", type: "configue" },
        { title: "Section Name", value: "sectionName", type: "configue" },
        { title: "Academic Year", value: "academicYearName", type: "configue" },
        { title: "Stream Name", value: "streamName", type: "configue" },
        { title: "Is Archived", value: "isArchived", type: "configue"},
    ],
    secondaryData: [
        { title: "Created At", value: "createdAt", type: "configue" },
        { title: "Updated At", value: "updatedAt", type: "configue", name: "updatedAt" },
        { title: "Created By", value: "createdByName", type: "configue" },
        { 
            title: "Updated By", 
            value: "updatedByName", 
            // type: "configue", 
            name: "updatedBy" 
        },
    ],
};